import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import StickyBox from "react-sticky-box";
import UserAvatar from "../common/UserAvatar";
import ImageConfig from "../../utility/configs/imageConfig";
import ConstConfig from "../../utility/configs/constConfig";
import { AuthContext } from "../../utility/services/AuthContext";
import Functions from "../../utility/services/Functions";
import { Form } from "react-bootstrap";
import ApiService from "../../utility/services/ApiService";
import Otp_model from "../common/components/Otp_model";

const TherapistSidebar = () => {
  // LOGICAL VARIABLES

  const [online_state_loading, setOnlineStateLoading] = useState(false);
  const { user, show_otp_modal, setShowOtpModal } = useContext(AuthContext);
  const { change_online_status } = ApiService();
  const { logOut, set_user_details } = Functions();
  const location = useLocation();

  const isUserDetails = user.details != null;
  const userDetails = user.details;
  const isPhoneFound =
    userDetails?.phone && userDetails.phone.toString().trim() != "";
  const isChangePhone = isPhoneFound;
  const PhoneFieldTitle = isChangePhone ? "Update Number" : "Add Number";

  const [url, setUrl] = useState(null);

  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);

  const chang_status_fun = async () => {
    if (!isUserDetails) return;
    setOnlineStateLoading(true);
    const status = {
      status: !userDetails.online_status,
    };
    const res = await change_online_status(status);
    if (res.status === 1) {
      await set_user_details();
      setOnlineStateLoading(false);
    }
  };

  return (
    <StickyBox offsetTop={20} offsetBottom={20} className="stickBox">
      <div className="usersidebar box-static">
        <div className="settings-header d-flex align-items-center">
          {isUserDetails && userDetails.role == "Therapist" && (
            <div className="toggle_swicth">
              <Form.Check // prettier-ignore
                label="Online"
                type="switch"
                checked={isUserDetails ? userDetails.online_status : false}
                id="custom-switch"
                reverse
                disabled={online_state_loading}
                onClick={() => {
                  chang_status_fun();
                }}
              />
            </div>
          )}

          <Link>
            <UserAvatar
              profileImage={isUserDetails && userDetails.profile_img ? userDetails.profile_img : ""}
              firstName={isUserDetails ? userDetails.first_name : ""}
              lastName={isUserDetails ? userDetails.last_name : ""}
              size="lg"
              className="avatar-lg rounded-circle"
              alt={isUserDetails ? `${userDetails.first_name} ${userDetails.last_name}` : "User"}
            />
          </Link>
          <div className="ms-3">
            <p className="mb-1">Welcome</p>
            <h3 className="mb-2">
              {isUserDetails &&
                user.details.first_name &&
                `${user.details.first_name} ${userDetails.last_name}`}
            </h3>
            {user.details?.phone && user.details.phone.trim() && (
              <h3 className="mb-0">{user.details.phone}</h3>
            )}
          </div>
        </div>
        <ul className="nav flex-column">
          <li className="nav-item">
            <Link
              className={"nav-link" + (url === "/dashboard" ? " active" : "")}
              to="/dashboard"
            >
              Appointments
            </Link>
          </li>
          {isUserDetails && userDetails.role == "Therapist" && (
            <>
              <li className="nav-item">
                <Link
                  className={
                    "nav-link" + (url === "/therapistearnings" ? " active" : "")
                  }
                  to={"/therapistearnings"}
                >
                  Earnings
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={
                    "nav-link" +
                    (url === "/therapistbankdetails" ? " active" : "")
                  }
                  to="/therapistbankdetails"
                >
                  Direct Deposit
                </Link>
              </li>
            </>
          )}

          <li className="nav-item">
            <Link
              className={"nav-link" + (url === "/chat" ? " active" : "")}
              to="/chat"
            >
              Messages
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={
                "nav-link" + (url === "/notificationsettings" ? " active" : "")
              }
              to="/notificationsettings"
            >
              Notification Settings
            </Link>
          </li>
          {isUserDetails && userDetails.role == "Patient" && (
            <>
              <li className="nav-item">
                <Link
                  className={
                    "nav-link" + (url === "/patientfavourite" ? " active" : "")
                  }
                  to="/patientfavourite"
                >
                  Favorites
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={
                    "nav-link" + (url === "/paymentsettings" ? " active" : "")
                  }
                  to="/paymentsettings"
                >
                  Payment Information
                </Link>
              </li>
            </>
          )}
          {
            <li className="nav-item">
              <Link
                className={"nav-link"}
                onClick={() => {
                  setShowOtpModal(true);
                }}
              >
                {PhoneFieldTitle}
              </Link>
            </li>
          }
          <li className="nav-item">
            <Link
              className={
                "nav-link" + (url === "/therapisteditProfile" ? " active" : "")
              }
              to={
                isUserDetails && userDetails.role == "Therapist"
                  ? "/therapisteditProfile"
                  : "/patientEditProfile"
              }
            >
              Profile Settings
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className="nav-link"
              as="button"
              onClick={() => {
                logOut();
              }}
            >
              Log Out
            </Link>
          </li>
        </ul>
      </div>
      {show_otp_modal && (
        <Otp_model
          show={true}
          onHide={() => {
            setShowOtpModal(false);
          }}
          verify_type="number_update"
        />
      )}
    </StickyBox>
  );
};

export default TherapistSidebar;
